import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { ROUTES } from '@/router/routes';

import { ProgressBullets } from '@/components/progress-bullets';

const FLOW_ROUTES = [
  { name: 'Get Started', href: ROUTES.GRADING_CASE_STEP_1 },
  { name: 'Readable Images', href: ROUTES.GRADING_CASE_STEP_2 },
  { name: 'Questions', href: ROUTES.GRADING_CASE_STEP_3 },
  { name: 'Signature', href: ROUTES.GRADING_CASE_STEP_4 },
];

const INSIGHTS_DR_FORM_ROUTES = [
  { name: 'Questions', href: ROUTES.INSIGHTS_DR_FORM_STEP_1 },
  { name: 'Follow Up', href: ROUTES.INSIGHTS_DR_FORM_STEP_2 },
];

type HeadingGradeFlowProps = {
  type?: 'grading' | 'insights-dr-form';
};

export function HeadingGradeFlow({ type = 'grading' }: HeadingGradeFlowProps) {
  const location: { pathname: string } = useLocation();
  const { caseId } = useParams();

  const steps = useMemo(() => {
    const currentPath = location.pathname.split('/').pop();
    if (!currentPath || !caseId) return [];

    const steps = type === 'grading' ? FLOW_ROUTES : INSIGHTS_DR_FORM_ROUTES;

    return steps.map((route, routeIndex, arr) => {
      const routePath = route.href.split('/').pop();

      if (currentPath === routePath) {
        return {
          ...route,
          status: 'current' as const,
          href: route.href.replace(':caseId', caseId),
        };
      }

      const currentPathIndex = arr.findIndex((r) => r.href.split('/').pop() === currentPath);
      const status = currentPathIndex > routeIndex ? ('complete' as const) : ('upcoming' as const);

      return { ...route, status, href: route.href.replace(':caseId', caseId) };
    });
  }, [location.pathname, caseId, type]);

  return <ProgressBullets steps={steps} />;
}
